import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Check, Close } from '@mui/icons-material';
import { Button, Chip, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { EditableDataGrid } from '../../../builderPackage/components/editableDataGrid/editableDataGrid';
import { useAppSelector } from '../../../store/hooks';
import { PDICheckKeys } from '../services/entity';
var InspectionQuestionGroup = function (props) {
    var _crud$PDICheckKeys$Co, _crud$PDICheckKeys$In, _currValue$filter, _currValue$, _currValue$2;
    var onChange = props.onChange, value = props.value, _a = props.name, name = _a === void 0 ? "Questions" : _a, error = props.error;
    var id = useParams().id;
    var currValue = value[name];
    console.log('currValue--00--99--', currValue);
    var crud = useAppSelector(function (state) { return state.crud; });
    var ProductListData = crud.ProductListData, AdjustmentListData = crud.AdjustmentListData, warehouseListData = crud.warehouseListData;
    var dynamicValues = crud === null || crud === void 0 || (_crud$PDICheckKeys$Co = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.ConfigurationPDICheck]) === null || _crud$PDICheckKeys$Co === void 0 || (_crud$PDICheckKeys$Co = _crud$PDICheckKeys$Co.data) === null || _crud$PDICheckKeys$Co === void 0 || (_crud$PDICheckKeys$Co = _crud$PDICheckKeys$Co.DynamicValues) === null || _crud$PDICheckKeys$Co === void 0 ? void 0 : _crud$PDICheckKeys$Co[0];
    var complaintConfig = (dynamicValues === null || dynamicValues === void 0 ? void 0 : dynamicValues.ComplaintConfiguration) || [];
    var isAllowedToAddCustomeQue = (_crud$PDICheckKeys$In = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.InpectionQuestionPDICheck]) === null || _crud$PDICheckKeys$In === void 0 ? void 0 : _crud$PDICheckKeys$In.data;
    var getSelectValuesByName = function (name) {
        var item = complaintConfig.find(function (entry) {
            var _entry$ComplaintTypeI;
            return (entry === null || entry === void 0 || (_entry$ComplaintTypeI = entry.ComplaintTypeId) === null || _entry$ComplaintTypeI === void 0 ? void 0 : _entry$ComplaintTypeI.Value) === name;
        });
        return item || [];
    };
    // const getSelectValuesByName = (name: string) => {
    //     const items = complaintConfig.filter(
    //         (entry: any) => entry?.ComplaintTypeId?.Value === name
    //     );
    //     console.log(`Matching items for "${name}":`, items);
    //     return items;
    // };
    var customerComplaint = getSelectValuesByName("1");
    var observation = getSelectValuesByName("2"); //2
    var defectCategory = getSelectValuesByName("5"); //5
    var actionTaken = getSelectValuesByName("3"); //3
    console.log('customerComplaint---', customerComplaint);
    console.log('observation----', observation);
    console.log('defectCategory----', defectCategory);
    console.log('actionTaken----', actionTaken);
    var columns = [{
            type: 'string',
            field: 'QuestionName',
            headerName: 'Name',
            editable: true,
            flex: 1,
            minWidth: 200,
            headerAlign: 'left'
        }, {
            type: 'string',
            field: 'InspectionCriteria',
            headerName: 'Inspection criteria',
            editable: true,
            flex: 1,
            minWidth: 220,
            headerAlign: 'center',
            valueFormatter: function (value) { return value ? value : '-'; }
        }, {
            type: 'string',
            field: 'IssueDescription',
            headerName: 'SOP',
            editable: true,
            flex: 1,
            minWidth: 120,
            headerAlign: 'center',
            valueFormatter: function (value) { return value ? value : '-'; }
        }, {
            type: 'actions',
            field: 'InspectionResult',
            headerName: 'Inspection result',
            flex: 1,
            minWidth: 150,
            // editable: id ? false : true,
            editable: false,
            headerAlign: 'center',
            valueSetter: function () { },
            renderCell: function (params) {
                var _params$row, _params$row3;
                return /*#__PURE__*/ React.createElement(Stack, {
                    display: "inline-flex",
                    direction: "row",
                    columnGap: 2
                }, /*#__PURE__*/ React.createElement(Button, {
                    id: "pass",
                    variant: (params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.InspectionResult) === 1 ? 'contained' : 'outlined',
                    color: "success",
                    size: "icon",
                    sx: {
                        p: 0.5
                    },
                    onClick: function (e) {
                        if (id) {
                            e.preventDefault();
                            e.stopPropagation();
                            return;
                        }
                        console.log(e);
                        var updatedRows = currValue === null || currValue === void 0 ? void 0 : currValue.map(function (r) {
                            var _params$row2;
                            return (r === null || r === void 0 ? void 0 : r.id) === (params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.id) ? _objectSpread(_objectSpread({}, r), {}, {
                                InspectionResult: 1
                            }) : r;
                        });
                        onChange === null || onChange === void 0 || onChange(e, updatedRows);
                    }
                }, /*#__PURE__*/ React.createElement(Check, {
                    id: "pass"
                })), /*#__PURE__*/ React.createElement(Button, {
                    id: "fail",
                    variant: (params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.InspectionResult) === 2 ? 'contained' : 'outlined',
                    color: "error",
                    size: "icon",
                    sx: {
                        p: 0.5
                    },
                    onClick: function (e) {
                        if (id) {
                            e.preventDefault();
                            e.stopPropagation();
                            return;
                        }
                        console.log(e);
                        var updatedRows = currValue === null || currValue === void 0 ? void 0 : currValue.map(function (r) {
                            var _params$row4;
                            return (r === null || r === void 0 ? void 0 : r.id) === (params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.id) ? _objectSpread(_objectSpread({}, r), {}, {
                                InspectionResult: 2
                            }) : r;
                        });
                        onChange === null || onChange === void 0 || onChange(e, updatedRows);
                    }
                }, /*#__PURE__*/ React.createElement(Close, {
                    id: "fail"
                })));
            }
        }, {
            type: 'number',
            field: 'Value',
            headerName: 'Actual value',
            flex: 1,
            headerAlign: 'center',
            editable: id == undefined || null ? true : false,
            minWidth: 180,
            align: 'center',
            valueSetter: function (value, row) {
                return _objectSpread(_objectSpread({}, row), {}, {
                    Value: value
                });
            }
        }, {
            type: 'string',
            field: 'Remarks',
            headerName: 'Remarks',
            flex: 1,
            headerAlign: 'center',
            minWidth: 180,
            editable: id == undefined || null ? true : false,
            align: 'center',
            preProcessEditCellProps: function (params) {
                var _ref, _params$props, _remarksValue$split, _params$row5;
                var remarksValue = (_ref = (params === null || params === void 0 || (_params$props = params.props) === null || _params$props === void 0 ? void 0 : _params$props.value) || '') === null || _ref === void 0 ? void 0 : _ref.trim();
                var wordCount = (_remarksValue$split = remarksValue.split(/\s+/)) === null || _remarksValue$split === void 0 || (_remarksValue$split = _remarksValue$split.filter(Boolean)) === null || _remarksValue$split === void 0 ? void 0 : _remarksValue$split.length;
                var hasLengthError = wordCount > 200;
                var inspectionResult = params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.InspectionResult;
                var isRequiredError = inspectionResult === 2 && !remarksValue;
                return _objectSpread(_objectSpread({}, params.props), {}, {
                    error: hasLengthError ? 'Max length 200 words' : isRequiredError ? 'Remarks ii required' : false
                });
            }
        }, {
            type: 'searchSelect',
            // type: 'singleSelect',
            field: 'CustomerVoiceName',
            headerName: 'Customer voice',
            flex: 1,
            headerAlign: 'center',
            editable: id == undefined || null ? true : false,
            minWidth: 180,
            align: 'center',
            // display: customerComplaint?.IsMandatory ? 'none' : 'inline-flex',
            valueOptions: (customerComplaint === null || customerComplaint === void 0 ? void 0 : customerComplaint.SelectValues) || [],
            // getOptionLabel: (value: any) => value?.DisplayName ?? '',
            // getOptionValue: (value: any) => value?.id,
            getOptionLabel: function (option) {
                var _option$ComplaintName;
                return (_option$ComplaintName = option === null || option === void 0 ? void 0 : option.ComplaintName) !== null && _option$ComplaintName !== void 0 ? _option$ComplaintName : '';
            },
            valueFormatter: function (value) {
                var _value$ComplaintName;
                return (_value$ComplaintName = value === null || value === void 0 ? void 0 : value.ComplaintName) !== null && _value$ComplaintName !== void 0 ? _value$ComplaintName : '';
            },
            valueSetter: function (value, row) {
                var _value$ComplaintName2, _value$id;
                return _objectSpread(_objectSpread({}, row), {}, {
                    CustomerVoiceName: (_value$ComplaintName2 = value === null || value === void 0 ? void 0 : value.ComplaintName) !== null && _value$ComplaintName2 !== void 0 ? _value$ComplaintName2 : null,
                    CustomerVoiceId: (_value$id = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id !== void 0 ? _value$id : null
                });
            },
            valueGetter: function (val, row) {
                var _row$CustomerVoiceNam, _row$CustomerVoiceId;
                return {
                    ComplaintName: (_row$CustomerVoiceNam = row === null || row === void 0 ? void 0 : row.CustomerVoiceName) !== null && _row$CustomerVoiceNam !== void 0 ? _row$CustomerVoiceNam : '',
                    id: (_row$CustomerVoiceId = row === null || row === void 0 ? void 0 : row.CustomerVoiceId) !== null && _row$CustomerVoiceId !== void 0 ? _row$CustomerVoiceId : ''
                };
            }
        }, {
            type: 'searchSelect',
            // type: 'singleSelect',
            field: 'ObservationId',
            headerName: 'Observation',
            flex: 1,
            headerAlign: 'center',
            editable: id == undefined || null ? true : false,
            minWidth: 180,
            align: 'center',
            valueOptions: (observation === null || observation === void 0 ? void 0 : observation.SelectValues) || [],
            getOptionLabel: function (option) {
                var _option$ComplaintName2;
                return (_option$ComplaintName2 = option === null || option === void 0 ? void 0 : option.ComplaintName) !== null && _option$ComplaintName2 !== void 0 ? _option$ComplaintName2 : '';
            },
            valueFormatter: function (value) {
                var _value$ComplaintName3;
                return (_value$ComplaintName3 = value === null || value === void 0 ? void 0 : value.ComplaintName) !== null && _value$ComplaintName3 !== void 0 ? _value$ComplaintName3 : '';
            },
            valueSetter: function (value, row) {
                var _value$ComplaintName4, _value$id2;
                return _objectSpread(_objectSpread({}, row), {}, {
                    ObservationName: (_value$ComplaintName4 = value === null || value === void 0 ? void 0 : value.ComplaintName) !== null && _value$ComplaintName4 !== void 0 ? _value$ComplaintName4 : null,
                    ObservationId: (_value$id2 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id2 !== void 0 ? _value$id2 : null
                });
            },
            valueGetter: function (val, row) {
                var _row$ObservationName, _row$ObservationId;
                return {
                    ComplaintName: (_row$ObservationName = row === null || row === void 0 ? void 0 : row.ObservationName) !== null && _row$ObservationName !== void 0 ? _row$ObservationName : '',
                    id: (_row$ObservationId = row === null || row === void 0 ? void 0 : row.ObservationId) !== null && _row$ObservationId !== void 0 ? _row$ObservationId : ''
                };
            }
            // getOptionLabel: (value: any) => value?.DisplayName ?? '',
            // getOptionValue: (value: any) => value?.id,
        }, {
            type: 'searchSelect',
            // type: 'singleSelect',
            field: 'DefectCategoryId',
            headerName: 'Defect category',
            flex: 1,
            headerAlign: 'center',
            editable: id == undefined || null ? true : false,
            minWidth: 180,
            align: 'center',
            valueOptions: (defectCategory === null || defectCategory === void 0 ? void 0 : defectCategory.SelectValues) || [],
            getOptionLabel: function (option) {
                var _option$ComplaintName3;
                return (_option$ComplaintName3 = option === null || option === void 0 ? void 0 : option.ComplaintName) !== null && _option$ComplaintName3 !== void 0 ? _option$ComplaintName3 : '';
            },
            valueFormatter: function (value) {
                var _value$ComplaintName5;
                return (_value$ComplaintName5 = value === null || value === void 0 ? void 0 : value.ComplaintName) !== null && _value$ComplaintName5 !== void 0 ? _value$ComplaintName5 : '';
            },
            valueSetter: function (value, row) {
                var _value$ComplaintName6, _value$id3;
                return _objectSpread(_objectSpread({}, row), {}, {
                    DefectCategoryName: (_value$ComplaintName6 = value === null || value === void 0 ? void 0 : value.ComplaintName) !== null && _value$ComplaintName6 !== void 0 ? _value$ComplaintName6 : null,
                    DefectCategoryId: (_value$id3 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id3 !== void 0 ? _value$id3 : null
                });
            },
            valueGetter: function (val, row) {
                var _row$DefectCategoryNa, _row$DefectCategoryId;
                return {
                    ComplaintName: (_row$DefectCategoryNa = row === null || row === void 0 ? void 0 : row.DefectCategoryName) !== null && _row$DefectCategoryNa !== void 0 ? _row$DefectCategoryNa : '',
                    id: (_row$DefectCategoryId = row === null || row === void 0 ? void 0 : row.DefectCategoryId) !== null && _row$DefectCategoryId !== void 0 ? _row$DefectCategoryId : ''
                };
            }
            // getOptionLabel: (value: any) => value?.DisplayName ?? '',
            // getOptionValue: (value: any) => value?.id,
        }, {
            type: 'searchSelect',
            // type: 'singleSelect',
            field: 'ActionTakenId',
            headerName: 'Action taken',
            flex: 1,
            headerAlign: 'center',
            minWidth: 180,
            align: 'center',
            editable: true,
            valueOptions: (actionTaken === null || actionTaken === void 0 ? void 0 : actionTaken.SelectValues) || [],
            getOptionLabel: function (option) {
                var _option$ComplaintName4;
                return (_option$ComplaintName4 = option === null || option === void 0 ? void 0 : option.ComplaintName) !== null && _option$ComplaintName4 !== void 0 ? _option$ComplaintName4 : '';
            },
            valueFormatter: function (value) {
                var _value$ComplaintName7;
                return (_value$ComplaintName7 = value === null || value === void 0 ? void 0 : value.ComplaintName) !== null && _value$ComplaintName7 !== void 0 ? _value$ComplaintName7 : '';
            },
            valueSetter: function (value, row) {
                var _value$ComplaintName8, _value$id4;
                return _objectSpread(_objectSpread({}, row), {}, {
                    ActionTakenName: (_value$ComplaintName8 = value === null || value === void 0 ? void 0 : value.ComplaintName) !== null && _value$ComplaintName8 !== void 0 ? _value$ComplaintName8 : null,
                    ActionTakenId: (_value$id4 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id4 !== void 0 ? _value$id4 : null
                });
            },
            valueGetter: function (val, row) {
                var _row$ActionTakenName, _row$ActionTakenId;
                return {
                    ComplaintName: (_row$ActionTakenName = row === null || row === void 0 ? void 0 : row.ActionTakenName) !== null && _row$ActionTakenName !== void 0 ? _row$ActionTakenName : '',
                    id: (_row$ActionTakenId = row === null || row === void 0 ? void 0 : row.ActionTakenId) !== null && _row$ActionTakenId !== void 0 ? _row$ActionTakenId : ''
                };
            }
            // getOptionLabel: (value: any) => value?.DisplayName ?? '',
            // getOptionValue: (value: any) => value?.id,
        }, {
            type: 'string',
            field: 'SAObservation',
            headerName: 'SA Suggetions',
            flex: 1,
            headerAlign: 'center',
            minWidth: 180,
            editable: id == undefined || null ? true : false,
            align: 'center',
            preProcessEditCellProps: function (params) {
                var _params$props2;
                var wordCount = (params === null || params === void 0 || (_params$props2 = params.props) === null || _params$props2 === void 0 || (_params$props2 = _params$props2.value) === null || _params$props2 === void 0 || (_params$props2 = _params$props2.trim()) === null || _params$props2 === void 0 || (_params$props2 = _params$props2.split(/\s+/)) === null || _params$props2 === void 0 ? void 0 : _params$props2.length) || 0;
                var hasError = wordCount > 200;
                return _objectSpread(_objectSpread({}, params.props), {}, {
                    error: hasError ? 'SA Observation exceeds the character limit of 200.' : false
                });
            }
        }];
    var handleRowClick = function (row) {
        // setRowData(row)
    };
    console.log('onChange', onChange);
    var failCount = currValue === null || currValue === void 0 || (_currValue$filter = currValue.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.InspectionResult) === 2; })) === null || _currValue$filter === void 0 ? void 0 : _currValue$filter.length;
    var filteredColumns = columns.filter(function (col) {
        if ((customerComplaint === null || customerComplaint === void 0 ? void 0 : customerComplaint.length) === 0 && col.field === 'CustomerVoiceName') {
            return false;
        }
        if ((observation === null || observation === void 0 ? void 0 : observation.length) === 0 && col.field === 'ObservationId') {
            return false;
        }
        if ((defectCategory === null || defectCategory === void 0 ? void 0 : defectCategory.length) === 0 && col.field === 'DefectCategoryId') {
            return false;
        }
        if ((actionTaken === null || actionTaken === void 0 ? void 0 : actionTaken.length) === 0 && col.field === 'ActionTakenId') {
            return false;
        }
        return true;
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: /*#__PURE__*/ React.createElement(Stack, {
            direction: 'row',
            position: 'relative'
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontSize: 'base',
            fontWeight: 'medium'
        }, currValue === null || currValue === void 0 || (_currValue$ = currValue[0]) === null || _currValue$ === void 0 ? void 0 : _currValue$.QuestionGroupName), /*#__PURE__*/ React.createElement(Chip, {
            label: failCount,
            color: "error",
            sx: {
                position: 'absolute',
                right: '-65px',
                top: '-2px',
                fontSize: 'sm',
                fontWeight: 'medium'
            }
        })),
        isCollapsible: true
        // columns={columns}
        ,
        columns: filteredColumns,
        disableAddRow: id ? true : (currValue === null || currValue === void 0 || (_currValue$2 = currValue[0]) === null || _currValue$2 === void 0 ? void 0 : _currValue$2.IsAllowToAddCustomQuestion) == true ? false : true,
        disableDeleteRow: id ? true : false,
        dataGridProps: {
            checkboxSelection: id ? false : true,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            sx: {
                borderRadius: 0,
                borderLeft: 'none',
                borderRight: 'none',
                borderTop: 0,
                fontSize: 'sm',
                fontWeight: 'medium'
            },
            isRowSelectable: function (params) {
                var _params$row6;
                return params !== null && params !== void 0 && (_params$row6 = params.row) !== null && _params$row6 !== void 0 && _params$row6.ControlId ? false : true;
            },
            onCellClick: function (params) {
                if (!(params.field == 'InspectionResult')) {
                    var _params$row7;
                    handleRowClick(params === null || params === void 0 || (_params$row7 = params.row) === null || _params$row7 === void 0 ? void 0 : _params$row7.InspectionResult);
                }
            },
            isCellEditable: function (params) {
                var field = params.field, row = params.row;
                console.log('row3333', row);
                var isNewRow = (row === null || row === void 0 ? void 0 : row.isNew) === true;
                if (field === 'QuestionName' || field === 'InspectionCriteria' || field === 'IssueDescription') {
                    if (row !== null && row !== void 0 && row.IsActive) {
                        return false;
                    }
                }
                return true;
            }
        },
        rows: currValue || [],
        onChange: onChange,
        error: error === null || error === void 0 ? void 0 : error[name]
    }));
};
export default InspectionQuestionGroup;
